import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { More } from './More'
import { Account } from './Account'
import { headerMode, screenOptions } from '../../../utils/helpers/commonUtils'
import { paths } from '../../links'
import Wallet from './Wallet'
import { getFocusedRouteNameFromRoute } from '@react-navigation/core'

export const HEADER_HEIGHT = 58

const { Navigator, Screen } = createStackNavigator()

export default ({ navigation, route }) => {
  React.useLayoutEffect(() => {
    const routeName = getFocusedRouteNameFromRoute(route) ?? ''
    const tabBarVisible = ![paths.Console.More.Wallet].includes(routeName)
    navigation.setOptions({ tabBarVisible })
  }, [navigation, route])

  return (
    <Navigator
      headerMode={headerMode}
      screenOptions={screenOptions}
      initialRouteName={paths.Console.More.MoreHome}
    >
      <Screen name={paths.Console.More.MoreHome} component={More} />
      <Screen name={paths.Console.More.Account} component={Account} />
      <Screen name={paths.Console.More.Wallet} component={Wallet} />
    </Navigator>
  )
}
